<h1 class="text-center mb-3">Client Configuration Secrets</h1>

@if (!addingSecret && !editingSecret)
{
    @if (!selectedClient)
    {
        <app-lt-generic-grid-wrapper #genericGrid
            [data]="allClients"
            [loading]="gettingClients"
            [columns]="clientColumns"
            [isResizeable]="true"
            [showExportToolbar]="false"
            [isReorderable]="false"
            [isSelectable]="true"
            [showSelectionColumn]="false"
            [showChangeSelection]="false"
            [sortDescriptions]="clientSortDescriptions"
            (itemSelected)="getClientFromGrid($event)">
        </app-lt-generic-grid-wrapper>
    }

    @if (selectedClient !== null)
    {
        <h4 class="float-start">Selected Client: {{selectedClient?.clientDisplayName}}</h4>

        <button matIconButton (click)="editClient()" class="ms-2">
          <i class="bi bi-pencil"></i>
        </button>

        <div class="my-2">

            <app-lt-png-table #secretsGrid [gridSettingsInput]="secretsGridSettings()" (editClicked)="editSecret($event)" ></app-lt-png-table>

        </div>

        <div class="text-center m-2">
            <button matButton="filled" color="primary" (click)="addSecret()">Add a secret?</button>
        </div>
    }
}
@else if (allGroupConfigPath)
{
    <div class="container">
        <div class="row">
            @if (editingSecret)
            {
                <div class="col-5">
                    <h4>IntegrationId: {{this.selectedIntegration.integrationId}}</h4>
                    <h4>IntegrationName: {{this.selectedIntegration.name}}</h4>
                    <h4>ServerId: {{this.selectedIntegration.serverId}}</h4>
                    <h4>ClientId: {{this.selectedIntegration.clientId}}</h4>
                    <br>
                </div>
            }

            @if (matchingSecrets && matchingSecrets.length > 0)
            {
                <div class="col-7">
                    <h4>Matching Secrets</h4>

                    <app-lt-generic-grid-wrapper #matchingSecretsGrid
                    [data]="matchingSecrets"
                    [columns]="matchingSecretsColumns"
                    [showColumnMenu]="false"
                    [showExportToolbar]="false"
                    [isReorderable]="false"
                    [isSelectable]="false"
                    [loading]="updatingSecretLoading">
                    </app-lt-generic-grid-wrapper>

                    <button matButton="filled" color="primary" (click)="confirmMultipleSecretsUpdate()">
                        Submit changes for all
                    </button>
                </div>
            }
        </div>
        <div class="row">
            <div class="col-7">
                @if (addingSecret)
                {
                    <mat-expansion-panel hideToggle>
                        <mat-expansion-panel-header>
                        <mat-panel-title>
                            Select Integration
                        </mat-panel-title>
                        @if (selectedIntegration)
                        {
                            <mat-panel-description>
                                <h6 class="p-0 m-0">Selected: {{selectedIntegration.name}} - {{selectedIntegration.dataSourceTypeId}}</h6>
                            </mat-panel-description>
                        }
                        </mat-expansion-panel-header>

                        <app-lt-generic-grid-wrapper #integrationsGrid
                          [data]="integrations"
                          [columns]="integrationColumns"
                          [isReorderable]="false"
                          [isSelectable]="true"
                          [showSelectionColumn]="true"
                          [showSelectDeselectButtons]="true"
                          [selectionfield]="'integrationId'"
                          [showColumnMenu]="false"
                          [showExportToolbar]="false"
                          [selectionColumnWidth]="60"
                          [selectionColumnHeader]="''"
                          [isFilterable]="false"
                          (itemSelected)="getIntegrationFromGrid($event)"
                          [loading]="secretGridViewIsLoading">
                        </app-lt-generic-grid-wrapper>
                    </mat-expansion-panel>

                    <br>
                    <br>
                }

                @if (editingSecret)
                {
                    <h6>Original Configuration Path:</h6>
                    <h6>DisplayName: {{clientConfigurationSecret.displayName}}</h6>
                    <h6>Element Path: {{clientConfigurationSecret.elementPath}}</h6>
                    <h6>Attribute Name: {{clientConfigurationSecret.attributeName}}</h6>
                }
                
                @if (!editingPath)
                {
                    <button matButton="filled" color="primary" (click)="editPath()">
                        Edit Path
                    </button>
                    <br>
                }
                @else
                {
                    <mat-expansion-panel hideToggle>
                        <mat-expansion-panel-header>
                        <mat-panel-title>
                            Select Configuration Path
                        </mat-panel-title>
                        @if (configurationPath)
                        {
                            <mat-panel-description>
                                <h6 class="p-0 m-0">Selected: {{configurationPath.displayName}} - {{configurationPath.elementPath}} - {{configurationPath.attributeName}}</h6>
                            </mat-panel-description>
                        }
                        </mat-expansion-panel-header>

                        <app-lt-generic-grid-wrapper #configPathGrid
                            [data]="allGroupConfigPath"
                            [columns]="configPathColumns"
                            [isReorderable]="false"
                            [isSelectable]="true"
                            [showSelectionColumn]="true"
                            [showSelectDeselectButtons]="true"
                            [selectionfield]="'configurationPathId'"
                            [showColumnMenu]="false"
                            [showExportToolbar]="false"
                            [selectionColumnWidth]="60"
                            [selectionColumnHeader]="''"
                            [isFilterable]="false"
                            (itemSelected)="getConfigPathFromGrid($event)"
                            [loading]="gettingConfigPaths">
                        </app-lt-generic-grid-wrapper>

                    </mat-expansion-panel>
                }

                <br>

                @if (editingSecret)
                {
                    @if (showMigration)
                    {
                        <h6>Original Secret Value: Configured in Disabled Secret Provider</h6>
                    }
                    @else
                    {
                        <h6>Original Secret Value: {{clientConfigurationSecret.secretValue}}</h6>
                    }
                }

                <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label>secretValue</mat-label>
                    <input matInput [(ngModel)]="secretValue" [disabled]="showMigration">
                </mat-form-field>

                <div class="d-flex flex-column mb-2">
                    @if (showMigration)
                    {
                        <div class="mb-2"><button matButton="filled" color="primary" (click)="openMigrateDialog()">Migrate Secret</button></div>
                    }

                    @if (addingSecret)
                    {
                        <div class="mb-2"><button matButton="filled" color="primary" (click)="confirmAdd()" [disabled]="showMigration">Submit</button></div>
                    }

                    @if (editingSecret)
                    {
                        <div class="mb-2"><button matButton="filled" color="primary" (click)="confirmUpdate()" [disabled]="showMigration">Submit</button></div>
                    }
                  <div><button matButton="filled" color="primary" (click)="cancelAddingEditingSecret()">Cancel</button></div>
                </div>

            </div>
        </div>
    </div>
}

<ng-template #confirmDialog>
  <mat-dialog-content>
    @if (editingSecret)
    {
        <h3>Secrets will be updated with the following information.</h3>

        @if (secretValue)
        {
            <h6>New Secret Value: {{secretValue}}</h6>
        }

        @if (configurationPath)
        {
            <h6>New Configuration Path: {{configurationPath.displayName}} - {{configurationPath.elementPath}}</h6>
        }

        <br/>

        @if (secretsToUpdate.length == 1)
        {
            <h4>The current secret values are below.</h4>
            <h6>Integration: {{clientConfigurationSecret.integrationName}}</h6>
            <h6>Element Path: {{clientConfigurationSecret.elementPath}}</h6>
            <h6>DisplayName: {{clientConfigurationSecret.displayName}}</h6>
            <h6>Attribute Name: {{clientConfigurationSecret.attributeName}}</h6>
            <h6>Secret Value: {{clientConfigurationSecret.secretValue}}</h6>

            <br/>

            <h4>To be updated for the following integration:</h4>
            <h6>Integration: {{clientConfigurationSecret.integrationName}}</h6>
        }
        @else
        {
            <h4>The current secret values are below.</h4>

            <h6>Element Path: {{clientConfigurationSecret.elementPath}}</h6>
            <h6>DisplayName: {{clientConfigurationSecret.displayName}}</h6>
            <h6>Attribute Name: {{clientConfigurationSecret.attributeName}}</h6>
            <h6>Secret Value: {{clientConfigurationSecret.secretValue}}</h6>

            <br/>

            <h4>To be updated for the following integrations:</h4>

            @for (secret of secretsToUpdate; track message) {
                <h6>    -{{secret.integrationName}}</h6>
            }
        }

        @if (!matchingSecrets)
        {
            <button matButton="filled" color="primary" class="m-1" [disabled]="editAddSecretLoading" (click)="submitEditSecret()">Update</button>
        }
        @else
        {
            <button matButton="filled" color="primary" class="m-1" [disabled]="editAddSecretLoading" (click)="submitEditMultipleSecrets()">Update</button>
        }
    }
    @else if (addingSecret)
    {
        <h3>The following secret will be added with the following information.</h3>
        
        <h6>Integration: {{clientConfigurationSecret.integrationName}}</h6>
        <h6>Element Path: {{clientConfigurationSecret.elementPath}}</h6>
        <h6>DisplayName: {{clientConfigurationSecret.displayName}}</h6>
        <h6>Attribute Name: {{clientConfigurationSecret.attributeName}}</h6>
        <h6>Secret Value: {{clientConfigurationSecret.secretValue}}</h6>

        <button matButton="filled" color="primary" class="m-1" [disabled]="editAddSecretLoading" (click)="submitAddSecret()">Add</button>
    }
    <button matButton="filled" color="primary" class="m-1" [disabled]="editAddSecretLoading" (click)="closeDialog()">Cancel</button>
  </mat-dialog-content>
</ng-template>

<ng-template #migrateDialog>
  <h2 mat-dialog-title>Migrate Secret to Other Secret Client?</h2>
  <mat-dialog-content>
    <div>
      Secret does not exist in current Secret Client, migrate secret from other Secret Client?
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button matButton="filled" matDiaogClose (click)="migrateSecret()">Migrate Secret</button>
    <button matButton="filled" matDiaogClose (click)="cancelMigrateSecret()">Close and Don't Migrate Secret</button>
  </mat-dialog-actions>
</ng-template>
